<template>
  <div class="whatsapp-contact-action-desktop">
    <div v-if="isCommunity" class="whatsapp-contact-action-desktop__community-wrap">
      <p class="whatsapp-contact-action-desktop__hint" :style="{ color: hintColor }">Leia o QR code ou clique no botão para entrar na comunidade</p>
      <div class="whatsapp-contact-action-desktop__community-row">
        <v-btn
          class="whatsapp-contact-action-desktop__btn"
          :href="whatsappLink"
          target="_blank"
          :color="getAssets.colors.whatsapp.contactButton"
          :style="{ color: getAssets.colors.whatsapp.contactButtonText }"
        >
          <v-icon class="mr-2">whatsapp</v-icon>
          {{ buttonLabel }}
        </v-btn>
        <div class="whatsapp-contact-action-desktop__qrcode whatsapp-contact-action-desktop__qrcode--framed">
          <qrcode-vue :value="whatsappLink" :size="80" level="L" />
        </div>
      </div>
    </div>
    <div v-else class="whatsapp-contact-action-desktop__plain">
      <v-btn
        class="whatsapp-contact-action-desktop__btn"
        :href="whatsappLink"
        target="_blank"
        :color="getAssets.colors.whatsapp.contactButton"
        :style="{ color: getAssets.colors.whatsapp.contactButtonText }"
      >
        <v-icon class="mr-2">whatsapp</v-icon>
        {{ buttonLabel }}
      </v-btn>
      <div class="whatsapp-contact-action-desktop__qrcode">
        <qrcode-vue :value="whatsappLink" :size="70" level="L" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'WhatsappContactCardActionDesktop',
  components: {
    QrcodeVue
  },
  props: {
    whatsappLink: {
      type: String,
      required: true
    },
    isCommunity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getAssets() {
      return this.GET_ASSETS
    },
    buttonLabel() {
      return this.isCommunity ? 'Entrar na comunidade' : 'Receber ofertas'
    },
    hintColor() {
      return this.getAssets.colors.whatsapp.contactCardDescription || 'rgba(0, 0, 0, 0.75)'
    }
  }
}
</script>

<style lang="scss" scoped>
$whatsapp-green: #25d366;

.whatsapp-contact-action-desktop {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.whatsapp-contact-action-desktop__community-wrap {
  border: 2px solid $whatsapp-green;
  border-radius: 8px;
  padding: 12px 14px;
  max-width: 100%;
  background-color: rgba(37, 211, 102, 0.04);
}

.whatsapp-contact-action-desktop__hint {
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  margin: 0 0 12px;
  line-height: 1.4;
}

.whatsapp-contact-action-desktop__community-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.whatsapp-contact-action-desktop__plain {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
}

.whatsapp-contact-action-desktop__btn {
  flex: 0 1 auto;
  text-transform: none;
  font-weight: 500;
  white-space: nowrap;
}

.whatsapp-contact-action-desktop__qrcode {
  flex-shrink: 0;

  ::v-deep canvas {
    display: block;
  }
}

.whatsapp-contact-action-desktop__qrcode--framed {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
